import { RatingDisplay } from "@/components/company/rating-display"
import { dataByPlatform } from "@/constants/platform/data-by-platform"
import type { Platform } from "@/constants/platform/platform"
import { cn } from "@/lib/utils"

export function PlatformRow({
  platform,
  rating,
  reviewCount,
  locationCount,
}: {
  platform: Platform
  rating?: number | null
  reviewCount?: number | null
  locationCount?: number
}) {
  const platformInfo = dataByPlatform[platform]
  if (!platformInfo) return null

  const hasData = reviewCount != null && reviewCount > 0

  return (
    <div className="flex items-center justify-between py-3">
      {/* Left: Platform name and review count */}
      <div>
        <div
          className={cn("text-sm font-bold tracking-wide uppercase", {
            "opacity-50": !hasData,
          })}
        >
          {platformInfo.title}
        </div>
        {hasData ? (
          <div className="text-muted-foreground text-sm">
            {reviewCount} Reviews
            {locationCount != null && locationCount >= 1 && (
              <>
                {" "}
                &middot; {locationCount}{" "}
                {locationCount === 1 ? "Location" : "Locations"}
              </>
            )}
          </div>
        ) : (
          <div className="wb-label-muted">Tracking</div>
        )}
      </div>

      {/* Right: Rating */}
      <div className="text-right">
        <RatingDisplay value={hasData ? (rating ?? null) : null} />
      </div>
    </div>
  )
}
